//import axios, { axiosPrivate } from "../api/axios"
import axiosPrivate from "../hooks/useAxiosPrivate";

const URL= '/cursos'

const crearCurso = async (data) => {
    try {
        const response = await axiosPrivate.post(URL,
                data,
            );
        return response?.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
};

const obtenerCursos = async (data) => {
    try {
        const response = await axiosPrivate.get(URL,
                data,
            );
        return response?.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
};

const editarCurso = async (data, _id) => {
    try {
        const response = await axiosPrivate.put(`${URL}/${_id}`,
                data,
            );
        console.log(response);
        return response?.data;
    } catch (error) {
        console.log(error.response);
        throw new Error(error.response.data.error);
    }
};

const eliminarCurso = async (_id) => {
    try {
        const response = await axiosPrivate.delete(`${URL}/${_id}`);
        console.log(response);
        return response?.data;
    } catch (error) {
        console.log(error.response);
        throw new Error(error.response.data.error);
    }
};


const CursoService={
    crearCurso,
    obtenerCursos,
    editarCurso,
    eliminarCurso,
}

export default CursoService;
